module.exports = __webpack_public_path__ + "static/img/科协批复.1a148171.jpg";